<script>
export default {
    name: 'IconCommentAdd'
}
</script>
<template>
    <svg
        class="base-icon icon-comment-add"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56 8v48L44 44H8V8h48zm-21 8h-6v7h-7v6h7v7h6v-7h7v-6h-7v-7z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
